import { getEmailTemplates } from '../../../modules/emailTemplates/emailTemplates.repository';
import { getSchema } from '../../../modules/schema/schema.repository';
import { Schema } from '../../../modules/schema/types';

export const getEmailTemplatesUseCase = () => {
  return getEmailTemplates();
};

export const getSchemaUseCase = (schemaId: number): Promise<Schema> => {
  return getSchema(schemaId);
};
